import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { AprEtsTabIVE2 as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEtsTabIVE2 = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const certificatesOnlyField = () => {
    const propertyName = pn<AprResponseModel>("certificatesOnly");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.certificatesOnly}{" "}
        {formatPercentTotal(props.data?.certificatesOnly, props.data?.totalParticipants4E2)}
      </DataDisplay>
    );
  };

  const associatesOnlyField = () => {
    const propertyName = pn<AprResponseModel>("associatesOnly");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.associatesOnly}{" "}
        {formatPercentTotal(props.data?.associatesOnly, props.data?.totalParticipants4E2)}
      </DataDisplay>
    );
  };

  const bachelorsOnlyField = () => {
    const propertyName = pn<AprResponseModel>("bachelorsOnly");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.bachelorsOnly} {formatPercentTotal(props.data?.bachelorsOnly, props.data?.totalParticipants4E2)}
      </DataDisplay>
    );
  };

  const bachelorAndAssociateField = () => {
    const propertyName = pn<AprResponseModel>("bachelorAndAssociate");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.bachelorAndAssociate}{" "}
        {formatPercentTotal(props.data?.bachelorAndAssociate, props.data?.totalParticipants4E2)}
      </DataDisplay>
    );
  };

  const moreThanOneCredentialField = () => {
    const propertyName = pn<AprResponseModel>("moreThanOneCredential");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.moreThanOneCredential} {formatPercentTotal(props.data?.moreThanOneCredential, props.data?.totalParticipants4E2)}
      </DataDisplay>
    );
  };

  const totalCredentialField = () => {
    const propertyName = pn<AprResponseModel>("totalCredential");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.totalCredential} {formatPercentTotal(props.data?.totalCredential, props.data?.totalParticipants4E2)}
      </DataDisplay>
    );
  };

  const noPostSecondaryCredentialField = () => {
    const propertyName = pn<AprResponseModel>("noPostSecondaryCredential");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.noPostSecondaryCredential} {formatPercentTotal(props.data?.noPostSecondaryCredential, props.data?.totalParticipants4E2)}
      </DataDisplay>
    );
  };

  const deceased4E2Field = () => {
    const propertyName = pn<AprResponseModel>("deceased4E2");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.deceased4E2} {formatPercentTotal(props.data?.deceased4E2, props.data?.totalParticipants4E2)}
      </DataDisplay>
    );
  };

  

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants4E2");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants4E2}</DataDisplay>
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Number of Participants by Type of Postsecondary Credential Earned</Typography>
        <Grid container spacing="lg">
          <Grid item xs={6}>
            <Grid container spacing="lg">
              {props.data?.certificatesOnly != null && (
                <Grid item xs={12}>
                  {certificatesOnlyField()}
                </Grid>
              )}
              <GridBreak />

              {props.data?.associatesOnly != null && (
                <Grid item xs={12}>
                  {associatesOnlyField()}
                </Grid>
              )}

              {props.data?.bachelorsOnly != null && (
                <Grid item xs={12}>
                  {bachelorsOnlyField()}
                </Grid>
              )}

              {props.data?.bachelorAndAssociate != null && (
                <Grid item xs={12}>
                  {bachelorAndAssociateField()}
                </Grid>
              )}

              {props.data?.moreThanOneCredential != null && (
                <Grid item xs={12}>
                  {moreThanOneCredentialField()}
                </Grid>
              )}

              {props.data?.totalCredential != null && (
                <Grid item xs={12}>
                  {totalCredentialField()}
                </Grid>
              )}

              {props.data?.noPostSecondaryCredential != null && (
                <Grid item xs={12}>
                  {noPostSecondaryCredentialField()}
                </Grid>
              )}

              {props.data?.deceased4E2 != null && (
                <Grid item xs={12}>
                  {deceased4E2Field()}
                </Grid>
              )}

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>

          <GridBreak />

          {/* <Grid item xs={6}>
            <PieChart
              id="pie-tab-a"
              dataSource={props.data?.chartValues}
              palette="Bright"
              title="Participants"
              width="100%"
            >
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid> */}
        </Grid>
      </Stack>
    </Card>
  );
};
